import {getUserInfoFromRequestCookies, setUserInfoFromRequestCookies} from '@stubhub/general-utils';

const DATE_COOKIE_FIELD_NAME = 'date';

/**
 * Retrieves the user's selected date from the request cookies.
 *
 * @param {Object} cookies - The cookies from the request.
 * @returns {string|null} - The user's selected date or null if not found.
 */
export const getUserSelectedDate = (cookies) => {
  const userInfo = getUserInfoFromRequestCookies(cookies);

  return userInfo && userInfo[DATE_COOKIE_FIELD_NAME];
};

/**
 * Stores the user's selected date in the request cookies.
 *
 * @param {Object} cookies - The cookies from the request.
 * @param {string} dateFilter - The date to store in the cookies.
 */
export const storeUserSelectedDate = (cookies, dateFilter) => {
  if (cookies && dateFilter) {
    const userInfo = getUserInfoFromRequestCookies(cookies);
    userInfo[DATE_COOKIE_FIELD_NAME] = dateFilter;
    setUserInfoFromRequestCookies(cookies, userInfo);
  }
};
